<template>
  <div class="container main has-submenu" :class="{ fullwidth : !loggedIn }">
    <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="panel panel-info">
      <div class="wrapper">
        <div class="banner">
          <h3 style="text-align:center;">Your wallets</h3>
          <div class="wallet">
            <wallet></wallet>
          </div>

                <div class="floating-button action-button"  title="Add a new Wallet" data-toast-delay="5">
                +
                  <ul class="action-list">
                      <li class="action-list-item" style="margin-top:0;" @click="LajanCashform">
                          <span><img src="../../../static/img/wallets/lajanCash.png" class="img-responsive" style="margin-top:0px" />LajanCash</span>
                      </li>
                      <!-- <li class="action-list-item" @click="MonCashform">
                          <span><img src="../../../static/img/wallets/monCash.png" class="img-responsive" style="margin-top:0px" />Mon Cash </span>
                      </li>
                      <li class="action-list-item">
                          <span><img src="../../../static/img/wallets/paypal.png" class="img-responsive" style="margin-top:0px" />PayPal </span>
                      </li> -->
                  </ul>
                </div>
          </div>
      </div>
    </div>
        <!-- modal Add LajanCash account -->
        <div id="add_lajancash" class="modal" data-easein="pulse" tabindex="-1" role="dialog" aria-labelledby="addbankLabel" aria-hidden="false">
            <form id="form" name="form" class="payment" @submit.prevent="addLajanCash">
                  <div class="modal-header" style="text-align:center; margin-top:0">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true">X</button>
                      <img src="../../../static/img/wallets/lajanCash.png" class="img-responsive" width="120" height="80" style="margin-left:auto; margin-right:auto; margin-top:0" />
                      <h2 class="panel-title">Add lajan cash wallet</h2>
                  </div>
                  <br>
                  <label for="phone">PHONE NUMBER</label><br>
                    <div class="form-group">
                      <div class="selectflag"></div>
                      <div class="intl-tel-input allow-dropdown separate-dial-code iti-sdc-4" style="max-width:480px;">
                      <div class="flag-container"><div tabindex="0" title="Haiti: +509" class="selected-flag">
                      <div class="iti-flag ht"></div> <div class="selected-dial-code" style="font-size:18; color:#636363;">+509</div>
                      <div class="iti-arrow"></div>
                      </div>
                      </div>
                      <input type="tel" autocomplete="off" class="form-control" v-model="lcphone" id="phone1" name="phone" placeholder=" 3410 1234" required="required" maxlength="8" minlength="8" style="height:40px; text-align: left;">
                      </div>
                    </div>
                    <br>
                  <label for="pin">YOUR PIN</label>
                  <input type="password" class="form-control" v-model="lcpin" id="pin" name="pin" placeholder="****" required="required" maxlength="4" minlength="4" style="height:40px; max-width:480px;" />
                  <br>
                  <div class="modal-footer">
                      <button class="blueButton" data-dismiss="modal" aria-hidden="true" style="margin-right:7%;">Cancel</button>
                      <!-- <vue-ladda :loading="loading" data-style="expand-right"> -->
                        <!-- Link account -->
                      <!-- </vue-ladda> -->
                        <button class="blueButton" style="float:right;" type="submit" id="load" data-loading-text="<i class='fa fa-spinner fa-spin' ></i> Linking your account...">Link account</button>

                      <!-- <vue-ladda :loading="loading" :progress="0-1">...</vue-ladda> -->
                  </div>
              </form>
        </div> <!-- modal End Add LajanCash-->
        <!-- modal Add MonCash account -->
        <div id="add_moncash" class="modal" data-easein="pulse" tabindex="-1" role="dialog" aria-labelledby="addbankLabel" aria-hidden="false">
            <form class="payment">
                  <div class="modal-header" style="text-align:center; margin-top:0">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true">X</button>
                      <img src="../../../static/img/wallets/monCash.png" class="img-responsive" width="120" height="100" style="margin-left:auto; margin-right:auto; margin-top:0" />
                      <h2 class="panel-title">Add Mon cash wallet</h2>
                  </div>
                  <br>
                  <label for="phone">PHONE NUMBER</label><br>
                  <input size="60" type="tel" class="form-control" id="phone" name="phone" placeholder=" 37 00 02 41" required="required" maxlength="8" minlength="8" />
                  <br><br>
                  <label for="pin">YOUR PIN</label>
                  <input type="password" class="form-control" id="pin" name="pin" placeholder="****" required="required" maxlength="4" minlength="4" />
                  <br>
                  <div class="modal-footer">
                      <button class="blueButton" data-dismiss="modal" aria-hidden="true" style="margin-right:7%;">Cancel</button>
                      <button class="blueButton" style="float:right;" type="submit">Link account</button>
                  </div>
              </form>
        </div> <!-- modal End Add MonCash-->
  </div>
  </div>
</div>
</template>
<script>
  // import Vue from 'vue'
  import { default as swal } from 'sweetalert2'
  import {HTTP} from '../../services/account-services.js'
  import wallet from './Wallet'
  import VueLadda from 'vue-ladda'
  export default {
    name: 'Wallets',
    components: {
      wallet,
      'vue-ladda': VueLadda
    },
    data() {
      return {
        lcphone: '',
        lcpin: '',
        LCwallet: {},
        isActive: false,
        loading: true
      }
    },
    methods: {
      LajanCashform() {
        $('#add_lajancash').modal()
      },
      MonCashform() {
        $('#add_moncash').modal()
      },
      checkStatus() {
        /* eslint brace-style: [2, "stroustrup"] */
        let url = '/wallet/status?phoneNumber=' + '509' + this.lcphone + '&pincode=' + this.lcpin
        HTTP.get(url
          // {
          //   // 'apiKey': '2d0baa3840e9ea900d9a556eb1922d14',
          //   'client': '509' + this.lcphone, // '50944405183',
          //   'currency': 'htg',
          //   'credentials': {
          //     'pincode': this.lcpin // '5183'
          //   }
        ).then((response) => {
          console.log('Response', response)
          if (response.data.data.status === 'active') {
            this.addLajanCash()
            console.log(response.data.message)
          }
          else {
            $('#add_lajancash').modal('hide')
            swal(
              'Error !',
              'This Lajan Cash account is not valid !',
              'error'
            )
          }
        })
      },
      addLajanCash() {
        console.log('Linking the account ...')
        let token = localStorage.getItem('authToken')
        let userId = localStorage.getItem('userId')
        let firstName = localStorage.getItem('firstName')
        let lastName = localStorage.getItem('lastName')
        let url = '/wallet?access_token=' + token
        let data = {
          phoneNumber: '509' + this.lcphone,
          firstName: firstName,
          lastName: lastName,
          pincode: this.lcpin,
          provider: 'lajancash',
          accountId: parseInt(userId)
        }
        console.log('Add LajanCash data', data)
        HTTP.post(url, data).then((response) => {
          console.log('Add lajan cash reponse:', response)
          $('#add_lajancash').modal('hide')
          if (response.data.message) {
            swal('Success!', 'Your LajanCash wallet has been successfully linked!', 'success')
          }
          else {
            swal('Error', 'Wallet link error', 'error')
          }
          this.$router.push('/account')
        })
          .catch((response) => {
            console.error(response)
            swal(
              'Error',
              'Something went wrong',
              'error'
            )
          })
      },
      addMonCash() {
        $('#add_moncash').modal()
      }
    },
    beforeMount() {
      setTimeout(() => {
        this.loading = false
      }, 2000)
    },
    mounted() {
      $('form').submit(function () {
        $('.blueButton').on('click', function() {
          let $this = $(this)
          $this.button('loading')
          setTimeout(function() {
            $this.button('reset')
          }, 500)
        })
      })
      var transitionTime = 0.3
      $(document).on('click', function (e) {
        var button = document.querySelector('.action-button.is-open')
        if (button) closeActions(button)
      })
      $('.action-button').on('click', function (e) {
        e.stopPropagation()
        var target = e.currentTarget
        if ($(target).hasClass('is-open')) return
        openActions(target)
      })
      function closeActions(button) {
        var list = button.querySelector('.action-list')
        $('.action-list').css('display', 'none')
        var dimensions = {
          width: list.clientWidth,
          height: list.clientHeight
        }
        button.classList.remove('is-open')
        requestAnimationFrame(morphList)

        function moveButton() {
          // var buttonPosition = 0

          list.style.transition = 'margin-right ' + transitionTime / 2 + 's ease'
          button.style.transition = 'margin-right ' + transitionTime / 2 + 's ease'

          list.style.marginRight = ''
          button.style.marginRight = ''
        }

        function morphList() {
          var buttonPosition = dimensions.width / 2

          button.style.transition = 'all ' + transitionTime + 's ease'
          list.style.transition = 'all ' + transitionTime + 's ease'

          button.style.marginRight = buttonPosition + 'px'
          list.style.marginRight = -buttonPosition + 'px'

          button.style.width = ''
          button.style.height = ''
          button.style.borderRadius = ''
          button.style.backgroundColor = ''

          list.style.opacity = ''

          $(list).one('transitionend', moveButton)
        }
      }

      function openActions(button) {
        var list = button.querySelector('.action-list')
        $('.action-list').css('display', 'unset')
        var dimensions = {
          width: list.clientWidth,
          height: list.clientHeight
        }

        button.classList.add('is-open')
        requestAnimationFrame(moveButton)

        function moveButton() {
          var buttonPosition = dimensions.width / 2 - 30
          list.style.transition = 'margin-right ' + transitionTime / 2 + 's ease'
          button.style.transition = 'margin-right ' + transitionTime / 2 + 's ease'

          list.style.marginRight = -buttonPosition + 'px'
          button.style.marginRight = buttonPosition + 'px'

          $(button).one('transitionend', morphButton)
        }

        function morphButton() {
          button.style.transition = 'all ' + transitionTime + 's ease'
          list.style.transition = 'all ' + transitionTime + 's ease'

          button.style.marginRight = '0px'
          list.style.marginRight = '0px'

          button.style.width = dimensions.width + 'px'
          button.style.height = dimensions.height + 'px'
          button.style.borderRadius = '0'
          button.style.backgroundColor = 'rgba(255, 152, 0, 0)'

          list.style.opacity = '1'
        }
      }
    },
    props: ['loggedIn']
  }
</script>
<style scoped>
@import url('../../../static/bower_components/area-code-flag/css/intlTelInput.css');
.floating-button {
  position: fixed;
  z-index: 100;
  width: 50px;
  height: 50px;
  background: #E91E63;
  color: #FFF;
  font-size: 2em;
  border-radius: 50%;
  top: 20vh;
  right: 50px;
  margin-top: -25px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-flex-direction: column;
  flex-direction: column;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
  -moz-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
  -webkit-transition: all 0.3s linear;
  -o-transition: all 0.3s linear;
  -moz-transition: all 0.3s linear;
  -ms-transition: all 0.3s linear;
  -kthtml-transition: all 0.3s linear;
  transition: all 0.3s linear;
}

.floating-button:hover {
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.3);
  margin-top: -30px;
}

.floating-button:active {
  box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.4);
  -webkit-box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.4);
  margin-top: -32px;
  background: #EC407A;
}

@media screen and (max-width: 600px) {
  header {
    height: 50vh;
  }
  .floating-button {
    top: 90vh;
    bottom: 10px;
    right: 30px !important;
  }
  .icon {
    display: block
  }
  section h1 {
    margin: 30px 0 0 0;
  }
  .added h1 {
    padding-top: 15px;
  }
}

@media screen and (max-width: 1200px) {
  .floating-button {
    right: 10px;
  }
}

/* Last style for card */

  /* floating buuton */

  * {
  box-sizing: border-box;
}

.action-list {
  color: initial;
  font-size: initial;
  text-align: initial;
  line-height: initial;
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: 0;
  /*display: none;*/
}
.action-button ul li {
  list-style-type: none;
  /*display: none;*/
}
.action-list-item {
  width: 160px;
  padding: 15px;
  white-space: nowrap;
  border-radius: 6px;
  background-color: white;
  border: solid 1px #e1e7eb;
  vertical-align: middle;
  margin-top:5px;
}
.action-list-item:hover {
  background-color: #f5f5f5;
  cursor: pointer;
  border: solid 1px #009bde;
}
.action-list-item i, .action-list-item span {
  display: inline-block;
  vertical-align: middle;
}
.action-list-item i {
  margin-right: 5px;
}
.action-list-item span{
  text-align: center;
}
@media (max-width: 480px) {
  .action-list{
    bottom: 380px;
  }
}
.action-list{
    display: none;
  }
  .selected-dial-code{
    font-size:18px !important;
  }
  .ladda-button {
    width: 50%;
    background: #2bc0e4;
    border: 0;
    padding: 10px 18px;
    font-size: 18px;
    cursor: pointer;
    color: #fff;
    border-radius: 2px;
    border: 1px solid transparent;
    -webkit-appearance: none;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Wallets/Wallets.vue